import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'carnetHeure', standalone: true, pure: true })
export class CarnetHeureFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    const padded = value.toString().padStart(4, '0');
    return `${padded.slice(0, 2)}h${padded.slice(2)}`;
  }
}

@Pipe({ name: 'carnetDuree', standalone: true, pure: true })
export class CarnetDureeFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    const padded = value.toString().padStart(4, '0');
    const hours = parseInt(padded.slice(0, 2), 10);
    const minutes = parseInt(padded.slice(2), 10);
    if (hours === 0) return `${minutes}min`;
    return minutes > 0 ? `${hours}h${String(minutes).padStart(2, '0')}` : `${hours}h`;
  }
}
